import React, { useState, useEffect } from 'react';
import style from './css/hero.module.css';

import image1 from '../../assets/networker.webp';
import image2 from '../../assets/web-design.webp'; // Add more images
import image3 from '../../assets/cybersecurity.jpg';

const images = [image1, image2, image3]; // Your carousel images

const Hero = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 4000); // Change image every 4 seconds
    return () => clearInterval(interval);
  }, []);

  return (
    <>
    <div className={style.heroContainer}>
      <div className={style.imageWrapper}>
        {images.map((img, index) => (
          <img
            key={index}
            src={img}
            alt={`Slide ${index}`}
            className={`${style.carouselImage} ${index === currentIndex ? style.active : ''}`}
          />
        ))}
      </div>
    </div>
      <header className={style.headerContainer}>
        <h1>Our Career Courses</h1>
        <p>
          A career in programming is not bound by age or gender, making it an accessible option for individuals of all backgrounds.
          One of the most compelling reasons to pursue a career in computer programming is the abundance of job opportunities available.
          Given our society's growing dependence on technology, it's evident that the programming sector offers enduring job prospects.
          While other industries may decline, programming continues to thrive and extend its influence across various aspects of daily life.
        </p>
      </header>
    </>
  );
};

export default Hero;
